
import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/auth';
import { LoadingState } from '@/components/invite/LoadingState';
import { ErrorState } from '@/components/invite/ErrorState';
import { InviteCard } from '@/components/invite/InviteCard';
import { useTripInvite } from '@/hooks/useTripInvite';
import { useJoinTrip } from '@/hooks/useJoinTrip';

const JoinPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const inviteCode = searchParams.get('code');
  const navigate = useNavigate();
  const { user, isLoading: authLoading } = useAuth();
  const { joinTrip, joining } = useJoinTrip();
  const { isLoading, tripDetails, error, joined, setJoined } = useTripInvite(inviteCode, user, authLoading);

  const handleJoinTrip = async () => {
    if (tripDetails) {
      const result = await joinTrip(tripDetails, user, inviteCode);
      if (result?.joined) {
        setJoined(true);
      }
    }
  };

  const handleViewTrip = () => {
    if (tripDetails) {
      navigate(`/trips/${tripDetails.id}/itinerary`);
    }
  };

  const handleGoHome = () => {
    navigate('/');
  };

  if (isLoading || authLoading) {
    return <LoadingState />;
  }

  if (error) {
    return <ErrorState error={error} onGoHome={handleGoHome} />;
  }

  return (
    <InviteCard
      tripDetails={tripDetails}
      joined={joined}
      joining={joining}
      onJoin={handleJoinTrip}
      onViewTrip={handleViewTrip}
      onGoHome={handleGoHome}
      isAuthenticated={!!user}
    />
  );
};

export default JoinPage;
